import Tracker from '@/tool/ta'
import { LOGIN_TYPE } from '@/enum'
import { customLocalStorage } from '@/tool/storage'
const user = {
  state: {
    userInfo: {},
    roleList: [],
    isLogin: false,
    userIpCountry: '',

    fpid: customLocalStorage.getItem(process.env.VUE_APP_FPID_KEY),
    token: '',
    loginType: 'role_id',
    postcode: '',
    validatePostcodeMap: {},

    // 首冲标识
    isFirst: false,

    // 是否展示税率提示标识
    isShowProductionTaxTips: false,
    webMailUid: customLocalStorage.getItem('web_mail_uid') || '',
  },
  mutations: {
    SET_USERINFO: (state, data) => {
      state.userInfo = data
    },
    SET_ROLE_LIST: (state, data) => {
      state.roleList = data
    },
    SET_IS_LOGIN: (state, data) => {
      state.isLogin = data
    },
    SET_USER_IP: (state, data) => {
      state.userIpCountry = data
    },
    SET_TOKEN: (state, data) => {
      state.token = data
    },
    SET_LOGIN_TYPE: (state, data) => {
      state.loginType = data || 'role_id'
      Tracker.ta.setSuperProperties({
        to_type: LOGIN_TYPE[state.loginType] || '',
      })
    },
    SET_LOGIN: (state, data) => {
      customLocalStorage.setItem(process.env.VUE_APP_FPID_KEY, (state.fpid = data.user_uid))
      state.isLogin = true
      state.userInfo = JSON.parse(JSON.stringify(data || {}))
      state.fpid = data.user_uid
    },
    SET_LOGOUT: (state) => {
      customLocalStorage.removeItem(process.env.VUE_APP_FPID_KEY)
      state.isLogin = false
      state.userInfo = {}
      state.fpid = ''
    },
    SET_POSTCODE: (state, data) => {
      state.postcode = data
    },

    SET_IS_FIRST: (state, data) => {
      state.isFirst = data
    },
    SET_VALIDATE_POSTCODE_MAP: (state, { postcode, isValid }) => {
      state.validatePostcodeMap = {
        ...state.validatePostcodeMap,
        [postcode]: isValid,
      }
    },
    SET_IS_SHOW_PRODUCTION_TAX_TIPS: (state, data) => {
      state.isShowProductionTaxTips = data
    },
    SET_WEB_MAIL_UID: (state, data) => {
      if (data) {
        state.webMailUid = data
        customLocalStorage.setItem('web_mail_uid', data)
      } else {
        customLocalStorage.removeItem('web_mail_uid')
        state.webMailUid = ''
      }
    },
  },
}

export default user
